import { FlowVendaTO } from "pages/registra-venda/registra-venda.model";
import { ColumnsTableMisc } from "utils/models";

export interface ItemRelatorioVendas {
  checkbox: boolean,
  iconAgrupar: string,
  cliente: string,
  clienteUUID: string,
  emissao: Date,
  modelo: string,
  numeroNotaFiscal: number,
  numeroPedido: number,
  serie: string,
  statusNotaFiscal: string,
  statusPedido: string,
  uuidNotaFiscal: string,
  chaveAcesso: string,
  uuidPedido: string,
  valorNota: number,
  valorPedido: number,
  vendedor: string,
  vendedorUUID: string,
  valorItensTroca: number;
  trocas: FlowRelatorioVendaDadosTrocaDTO[];
  acao?: string;
  emissaoNota: Date;
  crediario: boolean;
  pedidoAgrupamentoInfo: string | null;
}

export type FlowRelatorioVendaDadosTrocaDTO = {
  valorItensTroca: number;
  serieTroca: string;
  numeroNotaFiscalTroca: number;
  statusNotaFiscalTroca: string;
};

export interface IdadosFooterVendas {
  quantidade: number,
  totalPedido: number,
  totalNota: number;
}

export type ColumnsRelatorioVendas = ColumnsTableMisc<ItemRelatorioVendas>;

export enum StatusPedido {
  FATURADO = "Faturado",
  ABERTO = "Aberto",
  CANCELADO = "Cancelado",
  AGRUPADO = "Agrupado",
}

export enum StatusNotaFiscal {
  PENDENTE_ENVIO = "PENDENTE ENVIO",
  AUTORIZADA = "AUTORIZADA",
  CANCELADA = "CANCELADA",
  DENEGADA = "DENEGADA",
  PENDENTE = "PENDENTE",
  REJEITADA = "REJEITADA",
  PROCESSANDO = "EM PROCESSAMENTO",
  EM_TRANSMISSAO = "EM TRANSMISSÃO"
}

export enum CoresLegenda {
  VERDE = "VERDE",
  AMARELO = "AMARELO",
  VERMELHO = "VERMELHO",
  AZUL = 'AZUL',
  LARANJA = 'LARANJA',
  BRANCO = 'BRANCO',
  CINZA = 'CINZA',
  AZUL_INFANTO_JUVENO = 'AZUL_INFANTO_JUVENO'
}

export const Assosicacao: Record<CoresLegenda, { rgb: string; rgb2?: string; statusNotaFiscal: StatusNotaFiscal }> = {
  [CoresLegenda.VERDE]: {
    rgb: "#C7F6C7",
    rgb2: '#64c364',
    statusNotaFiscal: StatusNotaFiscal.AUTORIZADA,
  },
  [CoresLegenda.AMARELO]: {
    rgb: "rgba(202, 158, 0, 0.45)",
    rgb2: '#cda000',
    statusNotaFiscal: StatusNotaFiscal.REJEITADA,
  },
  [CoresLegenda.VERMELHO]: {
    rgb: "#ff5656",
    statusNotaFiscal: StatusNotaFiscal.CANCELADA,
  },
  [CoresLegenda.AZUL]: {
    rgb: "#8080FF",
    statusNotaFiscal: StatusNotaFiscal.DENEGADA,
  },
  [CoresLegenda.LARANJA]: {
    rgb: "#ff9d70",
    statusNotaFiscal: StatusNotaFiscal.PENDENTE,
  },
  [CoresLegenda.BRANCO]: {
    rgb: "#FFF",
    statusNotaFiscal: StatusNotaFiscal.PENDENTE_ENVIO,
  },
  [CoresLegenda.CINZA]: {
    rgb: "#405c806e",
    statusNotaFiscal: StatusNotaFiscal.PROCESSANDO,
  },

  [CoresLegenda.AZUL_INFANTO_JUVENO]: {
    rgb: "#44caff",
    statusNotaFiscal: StatusNotaFiscal.EM_TRANSMISSAO,
  },
};

export const AssociacaoByStatus = Object.entries(Assosicacao).reduce(
  (agg, curr) => {
    const [cor, { rgb, rgb2, statusNotaFiscal }] = curr;
    agg[statusNotaFiscal] = { rgb, rgb2, cor: cor as CoresLegenda };
    return agg;
  },
  {} as Record<StatusNotaFiscal, { rgb: string; rgb2?: string; cor: CoresLegenda; }>
);

export type StatusPedidoName = keyof typeof StatusPedido;

export const getAssociacao = (item: string) => {
  return Assosicacao[item as keyof typeof Assosicacao];
};

export type TDadosFooter = {
  quantidade: number,
  totalPedido: number,
  totalNota: number;
};

export interface IStatusProps {
  values: Array<string> | TipoRelatorioVenda,
  options: Array<StatusPedido | TipoRelatorioVenda>,
  onChange: (value: Array<StatusPedido> | TipoRelatorioVenda) => void;
  title?: string;
  multiple?: boolean;
  width: string;
  disabled?: boolean;
}

export interface ISituacaoPedidoProps {
  situacaoValues: Array<string>,
  situacaoOptions: Array<string>,
  isDisabled: boolean,
  onChangeSituacao: (value: StatusPedido) => void;
}

export type TVendasTableProps = {
  totalizadores: Array<ItemRelatorioVendas>,
  dadosFooter: IdadosFooterVendas,
  totalizadoresError: boolean,
  isLoading: boolean,
  onCancelaPedido: (uuid: string, motivo: string) => void;
  onShowImprimirDFE?: (url: string) => void;
  onNavegaPDV: (uuid: string, numeroPedido: number) => void;
  onAtualizarRelatorio: () => void;
  onShowImprimirOutros?: (uuid: string) => void;
  onShowRomaneioVenda?: (uuid: string) => void;
  onImprimirCrediario?: (uuid: string, emissao: Date | undefined) => void;
  onImprimirPreVenda?: (itemRelatorio: ItemRelatorioVendas) => void;
  onNavegaPreVenda?: (uuid: string, numeroPedido: number) => void;
  onVisualizar: (uuid: string, numeroPedido: number) => void;
  handleNavegaConferencia: (uuid: string) => void;
  onImprimirEtiquetaVenda: (uuid: string) => void;
  onImprimirEtiquetaSimplificada: (chaveAcesso: string) => void;
  selectedRows: string[];
  setSelectedRows: React.Dispatch<React.SetStateAction<string[]>>;
};

export type TDataVendaProps = {
  title: string,
  dataValue: string,
  onChangeData: (title: string, date: string) => void,
  dataInicio: string,
  dataFim: string,
  state: string;
};


export type TMenuItemAcoes = {
  canEditarVendedor?: boolean;
  canCancelarPedido?: boolean;
  canCancelarDfe?: boolean;
  canNavegaPreVenda?: boolean;
  canNavegaPDV?: boolean;
  canBaixarXml?: boolean;
  canExcluirNota?: boolean;
  canAtualizarSituacao?: boolean;
  canImprimirCrediario?: boolean;
  canImprimirEtiquetaSimplificada?: boolean;
  canVisualizar?: boolean;
  canConferir?: boolean;
  canImprimir?: boolean;
  canImprimirPreVenda?: boolean;
  canImprimirPedido?: boolean;
  canImprimirDanfe?: boolean;
  canImprimirRomaneio?: boolean;
  canImprimirEtiquetaVolume?: boolean;
  canAgrupar?: boolean;
};

export type TMenuItemRelatorioProps = {
  acoes?: TMenuItemAcoes;
  itemRef: React.MutableRefObject<ItemRelatorioVendas | null>;
  onCancelar?: () => void;
  onExcluirNota?: (chaveAcesso: string) => void;
  onOpenCancelarDFe?: () => void;
  onNavigatePDV?: (uuid: string, numeroPedido: number) => void;
  onImprimirDFE?: (uuid: string) => void;
  onImprimirPedido?: (uuid: string) => void;
  onEditarVendedor?: () => void;
  onImprimirRomaneio?: (uuid: string) => void;
  onImprimirPreVenda?: (itemRelatorio: ItemRelatorioVendas) => void;
  onImprimirCrediario?: (uuid: string, emissaoNota: Date | undefined) => void;
  onNavigatePreVenda?: (uuid: string, numeroPedido: number) => void;
  onDownloadXML?: (chaveAcesso: string) => void;
  onVisualizar: (uuid: string, numeroPedido: number) => void;
  onAtualizarSituacao?: (chaveAcesso: string) => void;
  onNavigateConferencia?: (uuid: string) => void;
  onImprimirEtiquetaVolume?: (uuid: string) => void;
  onImprimirEtiquetaSimplificada?: (chaveAcesso: string) => void;
};

export type TMotivo = {
  uuid: string,
  id: number,
  descritivo: string;
};

export type EtiquetaVolumeDTO = {
  emitenteRazaoSocial: string,
  emitenteLogradouro: string,
  emitenteComplemento: string,
  emitenteBairro: string,
  emitenteCep: string,
  emitenteCidadeEstado: string,
  emitenteTelefone: string,
  destinatarioRazaoSocial: string,
  destinatarioLogradouro: string,
  destinatarioComplemento: string | null,
  destinatarioNumero: string,
  destinatarioBairro: string,
  destinatarioCep: string,
  destinatarioCidadeEstado: string,
  destinatarioTelefone: string,
  notaSerie: string,
  notaNumero: string,
  pedidoNumero: string,
  pedidoNumeroEntrega: string,
  dataFaturamento: string,
  transportadoraRazaoSocial: string,
  volume: number;
};

export type EtiquetaSimplificadaDTO = {
  chaveAcesso: string;
  protocolo: string;
  tipoOperacao: string;
  numeroSerie: string;
  emissao: string;
  nomeRazaoSocialEmitente: string;
  identificacaoEmitente: string | null;
  inscricaoEstadualEmitente: string | null;
  enderecoEmitente: string | null;
  telefoneEmitente: string | null;
  nomeRazaoSocialDestinatario: string | null;
  identificacaoDestinatario: string | null;
  inscricaoEstadualDestinatario: string | null;
  telefoneDestinatario: string | null;
  enderecoDestinatario: string | null;
  informacaoFisco: string | null;
  transportadora: string | null;
  volumes: number;
};

export enum TipoRelatorioVenda {
  PEDIDO = "PEDIDO",
  NOTA = "NOTA"
}


export type FlowEditaVendedorTO = {
  vendedorUUID: string;
  pedidoUUID: string;
  outrosComissionados: Array<string>
}

export type TVisualizarVenda = {
  open: boolean,
  data: null | FlowVendaTO
}